import { Col, Pagination, Row, Spin } from "antd";
import "../Charts.css";
import { useMemo, useState } from "react";
import React, { useEffect } from "react";
import StatBox from "../../../../../components/StatBox/StatBox";
import { IoIosLink } from "react-icons/io";

function ChartClicksTable(props: any) {
  const {
    chartClicks,
    loadingPostClicksAnalytics,
    defaultCurrentPage,
    setDefaultCurrentPage,
    brand_color,
    carouselViews,
    loadingCarouselViews,
    selectedComponent,
    elem,
  } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  // Modified sorting logic
  const sortedChartClicks = useMemo(() => {
    if (!chartClicks) return [];
    return [...chartClicks].sort((a, b) => {
      // Case 1: If both items have count and idCount, sort by count only
      // if ((a.count && a.idCount) && (b.count && b.idCount)) {
        const aTotal = (a.count || 0) + (a.id && a.idCount ? a.idCount : 0);
        const bTotal = (b.count || 0) + (b.id && b.idCount ? b.idCount : 0);
        return bTotal - aTotal;
      // }
      // Case 2: If only one type of click exists, sort by whichever exists
      // const aValue = a.count || a.idCount || 0;
      // const bValue = b.count || b.idCount || 0;
      // return bValue - aValue;
    });
  }, [chartClicks]);

  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = currentPage * pageSize;
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setDefaultCurrentPage(page);
  };
  useEffect(() => {
    setCurrentPage(defaultCurrentPage);
  }, [defaultCurrentPage]);

  const totalSum = useMemo(() => {
    return (
      chartClicks?.reduce((sum: any, oneKey: any) => {
        return (
          sum +
          (oneKey?.count || 0) +
          (oneKey.id && oneKey.idCount ? oneKey.idCount : 0)
        );
      }, 0) || 0
    );
  }, [chartClicks]);

  const totalCarouselClicksSum = useMemo(() => {
    return (
      chartClicks?.reduce((sum: any, oneKey: any) => {
        return sum + (oneKey?.count || 0);
      }, 0) || 0
    );
  }, [chartClicks]);

  const totalPageClicksSum = useMemo(() => {
    return (
      chartClicks?.reduce((sum: any, oneKey: any) => {
        return sum + (oneKey.id && oneKey.idCount ? oneKey.idCount : 0);
      }, 0) || 0
    );
  }, [chartClicks]);




  const renderMediaOrDate = (oneKey: any) => {
    const renderDateBox = () => (
      <div className="analytics-chartClicks-thumbnail-div-text">
        <div
          className="analytics-chartClicks-thumbnail analytics-newsletter-thumbnail"
          style={{
            backgroundColor: "black",
            textAlign: "center",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.5rem",
          }}
        >
          {oneKey?.created_at &&
            new Date(oneKey.created_at).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })}
        </div>
      </div>
    );

    const renderLinkSectionBox = () => (
      <div className="analytics-chartClicks-thumbnail-div-text">
        <div
          className="analytics-chartClicks-thumbnail analytics-newsletter-thumbnail"
          style={{
            backgroundColor: "#e8e8e8",
            color: "black",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.2rem",
          }}
        >
          <IoIosLink />
        </div>
      </div>
    );

    const mediaUrls = oneKey.media_url?.split(",").map((url: any) => url.trim()).filter(Boolean) || [];
    const firstValidUrl = mediaUrls[0];

    if (oneKey.platform === "links-section") {
      return renderLinkSectionBox();
    }

    const isLinkedInSingleOrEmpty = oneKey.platform === "linkedin" && mediaUrls.length <= 1;

    if (isLinkedInSingleOrEmpty || !firstValidUrl) {
      return renderDateBox();
    }

    return (
      <img
        className="analytics-chartClicks-thumbnail"
        src={firstValidUrl}
        alt="feed"
      />
    );
  };
  const platfromItems = [
    { value: "twitter", label: "X Post" },
    { value: "linkedin", label: "LinkedIn Post" },
    { value: "newsletter", label: "Newsletter" },
    // {value:"misc",label:"Misc"},
  ];
  return (
    <>
      {loadingPostClicksAnalytics ? (
        <div className="spin">
          <Spin />
        </div>
      ) : (
        <>
          <div className="total-count">
            {/* <strong>Clicks : {totalSum}</strong> */}
            <div className="analytics-titles">
              {totalSum > 0 && (
                <StatBox
                  isLoading={loadingPostClicksAnalytics}
                  name="Clicks"
                  number={totalSum}
                  classname="stat-page"
                  brand_color={brand_color}
                />
              )}

              {!loadingCarouselViews &&
                selectedComponent &&
                carouselViews[selectedComponent] &&
                carouselViews[selectedComponent]?.[0]?.clicks > 0 && (
                  <StatBox
                    isLoading={loadingCarouselViews}
                    name="Page Views"
                    number={carouselViews[selectedComponent]?.[0]?.clicks}
                    classname="stat-page"
                    brand_color={brand_color}
                  />
                )}
            </div>
            <div className="analytics-titles mt-0">
              {(totalCarouselClicksSum > 0 || totalPageClicksSum > 0) && (
                <>
                  <StatBox
                    isLoading={loadingPostClicksAnalytics}
                    name="Carousel Clicks"
                    number={totalCarouselClicksSum}
                    classname="stat-page"
                    brand_color={brand_color}
                  />
                  <StatBox
                    isLoading={loadingPostClicksAnalytics}
                    name="Page Clicks"
                    number={totalPageClicksSum}
                    classname="stat-page"
                    brand_color={brand_color}
                  />
                </>
              )}
            </div>
          </div>
          {sortedChartClicks && sortedChartClicks.length > 0 && (
            <>
              <h3 className="breakdown-title">Breakdown</h3>
              <Row className="analytics-table">
                {sortedChartClicks
                  ?.slice(startIndex, endIndex)
                  ?.map((oneKey: any, index: any) => {
                    return (
                      <div key={index} className="analyticsTable">
                        <div className="sup-analytics-grid-item">
                          <div className="analytics-chartClicks-thumbnail-div">
                            {renderMediaOrDate(oneKey)}
                          </div>
                        </div>
                        {(oneKey.platform === "twitter" ||
                          oneKey.platform === "newsletter" ||
                          (oneKey.platform === "linkedin" &&
                            (oneKey.media_url === "" ||
                              (oneKey.media_url && oneKey.media_url.split(",").length === 1)))) ? (
                          <div className="item-name">
                            {platfromItems.find((item: any) => item.value === oneKey.platform)?.label || ""}
                          </div>
                        ) : (
                          <div className="item-name">{oneKey.name || ""}</div>
                        )}
                        <div className="right-aligned">
                          {oneKey.count && oneKey.idCount ? (
                            <>
                              <div>
                                <span className="metric-label">Carousel:</span>{" "}
                                {oneKey.count}
                              </div>
                              <div>
                                <span className="metric-label">Page:</span>{" "}
                                {oneKey.idCount}
                              </div>
                            </>
                          ) : (
                            <div>
                              <span className="metric-label">Clicks:</span>{" "}
                              {oneKey.count || oneKey.idCount}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
              </Row>
            </>
          )}
          {sortedChartClicks && sortedChartClicks.length > pageSize && (
            <div className="mt-4">
              <Pagination
                align="center"
                current={currentPage}
                total={sortedChartClicks?.length}
                pageSize={pageSize}
                onChange={handlePageChange}
                showSizeChanger={false}
                showQuickJumper
              />
            </div>
          )}
        </>
      )}
    </>
  );
}

export default ChartClicksTable;
